import { appClient } from 'api/apiClient';
import type { Paginated } from 'api/v1Helpers';
import type { SavedCard } from 'types/paymentMethods';

export async function listMyPaymentMethods(): Promise<Paginated<SavedCard>> {
    return appClient.get<Paginated<SavedCard>>('me/payment-methods');
}

/** Prefer Stripe default card; otherwise first saved card. Never invents an id. */
export function pickPreferredCard(cards: SavedCard[]): SavedCard | null {
    if (!cards?.length) return null;
    return cards.find((c) => c.isDefault) ?? cards[0] ?? null;
}
